import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import CustomizedSwitch from 'src/components/customized-switch'
import styles from '../styles'

const WhiteLabelHeader = ({
  classes,
  userControl,
  emailProviderEnabled,
  onToggle,
}) => {
  return (
    <div className={classes.headerContainer}>
      <div className={classes.switch}>
        {userControl && (
          <CustomizedSwitch
            checked={emailProviderEnabled}
            onChange={onToggle}
          />
        )}
        <Typography className={classes.header}>White label email</Typography>
      </div>
      <Typography className={classes.description}>
        Send custom emails from your own domain using supported providers.
      </Typography>
    </div>
  )
}

export default withStyles(styles)(WhiteLabelHeader)
